import PropTypes from 'prop-types';
import 'rc-checkbox/assets/index.css';
import React from 'react';
import { ModalCreateIndividual, ModalCreateLegal } from './components';
import './style.scss';

const ModalCreateClient = ({
  onSubmit,
  onClose,
  pending,
  type,
  clientNumber,
  isFromMainPage,
  defaultValues,
  historyParams,
}) => {
  if (type === 'individ') {
    return (
      <ModalCreateIndividual
        onSubmit={onSubmit}
        onClose={onClose}
        pending={pending}
        clientNumber={clientNumber}
        isFromMainPage={isFromMainPage}
        defaultValues={defaultValues}
        historyParams={historyParams}
      />
    );
  } else if (type === 'legal') {
    return <ModalCreateLegal defaultValues={defaultValues} onSubmit={onSubmit} onClose={onClose} pending={pending} />;
  } else {
    return <></>;
  }
};

ModalCreateClient.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  pending: PropTypes.bool,
  type: PropTypes.string.isRequired,
  clientNumber: PropTypes.string,
  isFromMainPage: PropTypes.bool,
  defaultValues: PropTypes.object,
  historyParams: PropTypes.object,
};

ModalCreateClient.defaultProps = {
  pending: false,
  isFromMainPage: false,
  clientNumber: '',
  defaultValues: {},
  historyParams: {},
};

export { ModalCreateClient };
